import * as React from 'react';

const SvgDeleteTable = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.12"
      d="M19.4004 8.59961V16.2002C19.4004 17.0498 19.3997 17.651 19.3613 18.1211C19.3235 18.5842 19.2519 18.8676 19.1387 19.0898C18.9086 19.5414 18.5414 19.9086 18.0898 20.1387C17.8676 20.2519 17.5842 20.3235 17.1211 20.3613C16.651 20.3997 16.0498 20.4004 15.2002 20.4004H8.7998C7.9502 20.4004 7.34896 20.3997 6.87891 20.3613C6.41576 20.3235 6.13234 20.2519 5.91016 20.1387C5.45863 19.9086 5.0914 19.5414 4.86133 19.0898C4.74811 18.8676 4.67651 18.5842 4.63867 18.1211C4.6003 17.651 4.59961 17.0498 4.59961 16.2002V8.59961H19.4004Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <path
      d="M4 7.9966C3.83599 7.99236 3.7169 7.98287 3.60982 7.96157C2.81644 7.80376 2.19624 7.18356 2.03843 6.39018C2 6.19698 2 5.96466 2 5.5C2 5.03534 2 4.80302 2.03843 4.60982C2.19624 3.81644 2.81644 3.19624 3.60982 3.03843C3.80302 3 4.03534 3 4.5 3H19.5C19.9647 3 20.197 3 20.3902 3.03843C21.1836 3.19624 21.8038 3.81644 21.9616 4.60982C22 4.80302 22 5.03534 22 5.5C22 5.96466 22 6.19698 21.9616 6.39018C21.8038 7.18356 21.1836 7.80376 20.3902 7.96157C20.2831 7.98287 20.164 7.99236 20 7.9966M10 13H14M4 8H20V16.2C20 17.8802 20 18.7202 19.673 19.362C19.3854 19.9265 18.9265 20.3854 18.362 20.673C17.7202 21 16.8802 21 15.2 21H8.8C7.11984 21 6.27976 21 5.63803 20.673C5.07354 20.3854 4.6146 19.9265 4.32698 19.362C4 18.7202 4 17.8802 4 16.2V8Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgDeleteTable;
